import styled, { css } from "styled-components/macro";
import tw from "twin.macro";
import { media } from "../../../styles/global-style";
import { Button, ImageBoxUtils } from "../../utils/styles/Utils";

export const Section = styled.section`
  ${tw`py-20 px-0`};
`;

export const Pane = styled.div`
  ${tw`w-1/2 py-0 p-3.5`};

  ${media.tablet} {
    ${tw`w-full p-8`}
  }

  &:first-child {
    ${tw`order-2`}
  }

  &:first-child {
    ${tw`order-1`}
  }
`;

export const Inputs = styled.form``;

export const Group = styled.div`
  ${tw`w-full mb-8`};

  &:last-child {
    margin-bottom: 0px;
  }
`;

const input = css`
  ${tw`block w-full h-12 rounded-3xl border-none font-normal text-base bg-white25 py-0 px-5 text-blueDarkClr`};

  font-family: inherit;
  border: 1px solid transparent;
  transition: border-color 0.3s ease-in-out;

  &:focus {
    ${tw`border-white40`}
  }
`;

export const Input = styled.input`
  ${input}
`;

export const TextArea = styled.textarea`
  ${input};
  ${tw`h-32 resize-none pt-3.5`};
`;

export const Submit = styled.button`
  ${Button};
  font-family: inherit;
`;

export const Item = styled.div`
  ${tw`m-0 mb-8 p-0 pr-5`};
`;

export const Title = styled.h3`
  ${tw`text-xl capitalize m-0 mb-1`};
`;

export const Desc = styled.p``;

export const MediaContainer = styled.div``;

export const MediaLink = styled.a`
  ${tw`inline-flex items-center justify-center h-10 w-10 bg-white25 text-primaryClr rounded-half border border-solid border-white40
    m-0 mt-1.5 mr-3 cursor-pointer
  `};

  transition: all 0.3s ease;

  &:hover {
    ${tw`text-white bg-primaryClr`}
  }
`;

export const MediaIcon = styled.i``;
